import { nanoid } from "@reduxjs/toolkit";
import { useMemo } from "react";

export default function useControlId() {
    return useMemo(nanoid, []);
}
